<template>
  <div id="app">
        <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-3" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Flight-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" :label="$t('Search')"
                append-icon="search"></v-text-field>
                <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm4 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarihi"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm4 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarihi"></tarihcomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                           <v-badge color="white"  :overlap="true">
                              <template v-slot:badge>
                                  <v-icon v-if="filtrevarmi" large color="green">
                                        check_circle_outline    
                                  </v-icon>
                              </template>

                                 <v-btn small="" @mouseenter="tooltip = true"
                                     @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                                     color="info" fab dark>
                                     <v-icon>filter_list</v-icon>
                                 </v-btn>
                                  <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                 <span>{{$t('Add-Search-Filter')}}</span>
                             </v-tooltip>

                            </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex v-if xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headers" :rows-per-page-items=[20,100] :items="itemsichat"
                                :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                                  <td class="text-xs-left">{{ props.item.YolcuAdi}}</td>
                                  <td class="text-xs-center">{{ props.item.FiyatTur}}</td>
                                  <td class="text-xs-center">{{ props.item.UcusTipi}}</td>
                                  <td class="text-xs-center">{{ props.item.YolcuAdet}}</td>
                                  <td class="text-xs-center">{{ props.item.UcusTarihi | dateformat}}</td>
                                  <td class="text-xs-left">{{ props.item.UcusHY}}</td>
                                  <td class="text-xs-center">{{ props.item.UcusNo}}</td>
                                  <td class="text-xs-left">{{ props.item.Parkur}}</td>
                                  <td class="text-xs-left">{{ props.item.Class}}</td>
                                  <td class="text-xs-left">{{ props.item.ClassTip}}</td>
                                  <td class="text-xs-center">{{ props.item.UcusSaat}}</td>
                                  <td class="text-xs-right">{{ props.item.VarisTarihi | dateformat}}</td>
                                  <td class="text-xs-center">{{ props.item.VarisSaat}}</td>
                                  <td class="text-xs-center">{{ props.item.FareBases}}</td>
                                  <td class="text-xs-center">{{ props.item | birlestir }}</td>

                                  <!-- <td v-if="props.item.AcentaKod !=null &&  props.item.AcentaKod !=''" class="text-xs-left">{{ props.item.AcentaKod}}</td>
                                  <td v-if="props.item.CariKod !=null && props.item.CariKod !=''" class="text-xs-left">{{ props.item.CariKod}}</td> -->

                                  <td class="text-xs-center">{{ props.item.Aktarma}}</td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                  {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                              
                              <cariaracomp v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="Rapor.CariKodu" v-model="Rapor.CariKodu"></cariaracomp>

                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" v-model="Rapor.BiletNo" :label="$t('Ticket-Number')">
                              </v-text-field>
                            </v-flex>
                                <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" v-model="Rapor.UcusNo" :label="$t('Flight-No')">
                              </v-text-field>
                            </v-flex>
                             <v-flex xs12 sm12>
                               <v-select hide-details="" :items="itemstip" :label="$t('Ticket-Type')"
                                   item-text="text" v-model="Rapor.BiletTip"
                                   item-value="value">
                               </v-select>
                              </v-flex>

                               <v-flex xs12 sm12 md12>
                            <v-layout justify-space-between column>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-layout>
                          </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'


  export default {
    data() {
      return {
        mailDialog: false,
        mailValid: false,
        mailLoading: false,
        mailPayload: {
          To: "",
          AgencyName: "",
          DocType: "Kesen Kişi Performans Raporu - Performance Analysis of Ticket Agent", 
          AgentFullName: "",
          CustomBody: ""
        },
        rules: {
          required: v => !!v || 'Zorunlu alan',
          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
        },
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi:false,
        sonuc: 0,
        itemscari: [],
        dipToplam: {
          SonucPosTutar: 0,
          ToplamBiletPosTutar: 0,
          ToplamBiletTutar: 0,
          ToplamCariAlacak: 0,
          ToplamCariBorc: 0,
          ToplamCariPosTutar: 0
        },
        bankapositems: [],
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        referansitems: [],
        evraktipi: [],
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        Rapor: {
          BiletNo: null,
          UcusNo: null,
          CariKodu: null,
          HavayoluKodu: null,
          SirketKodu: null,
          BaslangicTarihi: null,
          BitisTarihi: null,
          BiletTip :0
        },
        valid: true,
        tumsirketler: '',
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsichat: [],
        itemsdishat: [],
        masrafmerkezikodu: 'Masraf',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
      beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

       this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    filters: {

      birlestir: function (s) {
        var a
        var c
        if (s.AcentaKod != null && s.AcentaKod != '') {
          a = s.AcentaKod
        } else {
          a = '-'
        }
        if (s.CariKod != null && s.CariKod != '') {
          c = s.CariKod
        } else {
          c = '-'
        }
        return a + '/' + c
      },

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      masrafmerkezicomp,
      havayollaricomp,
      yetkidialog,
      cariaracomp
    },
    watch: {

    },
    methods: {
     
 
  openMailDialog: function () {
    var pageDocType = "Uçuş Raporu - Flight Report";
    if (!this.mailPayload) this.mailPayload = {};
    this.mailPayload.DocType = pageDocType;

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
      this.$refs.mailForm.resetValidation();
    }

    this.mailDialog = true;
  },

  closeMailDialog: function () {
    this.mailDialog = false;
  },

  sendMail: function () {
    var _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {
      return;
    }

    var bas = (_this.Rapor && _this.Rapor.BaslangicTarihi) ? new Date(_this.Rapor.BaslangicTarihi) : null;
    var bit = (_this.Rapor && _this.Rapor.BitisTarihi) ? new Date(_this.Rapor.BitisTarihi) : null;
    if (!(bas && bit && bas <= bit)) {
      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');
      _this.snackbar = true;
      return;
    }

    var credentialsRaw = window.localStorage.getItem('credentials');
    var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
    var companyCode = (_this.tumsirketler === true)
      ? '0'
      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    var havayoluKod = (_this.havayolubil && _this.havayolubil.havayolukodu) ? _this.havayolubil.havayolukodu : null;

    var inputObj = {
      SirketKodu: companyCode,
      BiletNo: (_this.Rapor && _this.Rapor.BiletNo) ? _this.Rapor.BiletNo : null,
      UcusNo: (_this.Rapor && _this.Rapor.UcusNo) ? _this.Rapor.UcusNo : null,
      CariKodu: (_this.Rapor && _this.Rapor.CariKodu) ? _this.Rapor.CariKodu : null,
      HavayoluKodu: havayoluKod,
      BaslangicTarihi: (_this.Rapor && _this.Rapor.BaslangicTarihi) ? _this.Rapor.BaslangicTarihi : null,
      BitisTarihi: (_this.Rapor && _this.Rapor.BitisTarihi) ? _this.Rapor.BitisTarihi : null,
      BiletTip: (_this.Rapor && typeof _this.Rapor.BiletTip !== 'undefined') ? _this.Rapor.BiletTip : 0
    };

    var pageDocType = "Uçuş Raporu - Flight Report";
    var mailObj = {
      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",
      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",
      DocType: (_this.mailPayload && _this.mailPayload.DocType) ? _this.mailPayload.DocType : pageDocType,
      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",
      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""
    };

    var payload = { Input: inputObj, Mail: mailObj };

    _this.mailLoading = true;

    var endpoint = auth.API_URL + 'api/TicketReport/MailGonderUcusRaporuExcel';

    _this.$http.post(
      endpoint,
      payload,
      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
    ).then(function () {
      _this.mailLoading = false;
      _this.mailDialog = false;
      _this.text1 = 'Mail gönderildi.';
      _this.snackbar = true;
    }, function (err) {
      _this.mailLoading = false;
      var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
      var msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';
      _this.text1 = msg;
      _this.snackbar = true;
    });
  },


      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
    computed:{
          itemstip(){
            return[
          {
            text:this.$t('All'),
            value:0
          },
          {
            text:this.$t('Open-Tickets-Only'),
            value:1
          },
          {
            text:this.$t('Except-for-Open-Tickets'),
            value:2
          }]
          },
        headers(){
          return [{
            text: this.$t('Ticket-No'),
            value: 'BiletNo',
            sortable: false
          },
          {
            text: this.$t('Name-of-Passenger'),
            value: 'YolcuAdi',
            sortable: false

          },
          {
            text: 'FT',
            value: 'FiyatTur',
            sortable: false

          },
          {
            text: 'HT',
            value: 'UcusTipi',
            sortable: false

          },
          {
            text: 'Pax',
            value: 'YolcuAdet',
            sortable: false

          },
          {
            text: this.$t('Flight-Date'),
            value: 'UcusTarihi',
            sortable: false
          },
          {
            text: this.$t('Airline'),
            value: 'UcusHY',
            sortable: false
          },
          {
            text: this.$t('Flight-No'),
            value: 'UcusNo',
            sortable: false
          },
          {
            text: this.$t('Route'),
            value: 'Parkur',
            sortable: false
          },
          {
            text: this.$t('Class'),
            value: 'Class',
            sortable: false
          },
          {
            text: 'ClassTip',
            value: 'ClassTip',
            sortable: false
          },
          {
            text: this.$t('Flight-Time'),
            value: 'UcusSaat',
            sortable: false
          },
          {
            text: this.$t('Arrival-Date'),
            value: 'VarisTarihi',
            sortable: false
          },
          {
            text: this.$t('Arrival-Time'),
            value: 'VarisSaat',
            sortable: false
          },
          {
            text: this.$t('FareBases'),
            value: 'FareBases',
            sortable: false
          },
          {
            text: 'Acenta/' + this.$t('Customer'),
            value: 'AcentaKod',
            sortable: false
          },
          {
            text: this.$t('Transfer-v2'),
            value: 'Aktarma',
            sortable: false
          }
        ]
        },
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })


  }


  function filtrekayit() {
    this.filtrevarmi=true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {
    this.filtrevarmi=false
    this.dialogfiltre = false
    this.Rapor.CariKodu = null
    this.Rapor.HavayoluKodu = null
    this.havayolubil.havayolukodu = null
    this.Rapor.BiletNo = null
    this.Rapor.UcusNo = null
    this.Rapor.BiletTip=0
    this.tumsirketler = ''
    this.getList();
  }

  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var listreferans = [];


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.havayolubil.havayolukodu != null) {
          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/FlightReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.itemsichat = response.body
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var listreferans = [];


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.havayolubil.havayolukodu != null) {
          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/FlightReportHtml', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> UÇUŞ RAPORU </title>','<title> FLIGHT REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>UÇUŞ RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>FLIGHT REPORT</font>")
             bodyhtml=bodyhtml.toString().replace("Hava Yolu Code :","Airline Code :")
             bodyhtml=bodyhtml.toString().replaceAll("Bilet No","Ticket No")
             bodyhtml=bodyhtml.toString().replace("Uçuş Tarihi","Flight Date")
             bodyhtml=bodyhtml.toString().replace("HY","AL")
             bodyhtml=bodyhtml.toString().replace("Uçuş No","Flight No")
             bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")
             bodyhtml=bodyhtml.toString().replace("Void Tarihi","Void Date")
             bodyhtml=bodyhtml.toString().replace("Satış Tarihi","Sales Date")
             bodyhtml=bodyhtml.toString().replace("Kesim Tarihi","Cutting Date")
             bodyhtml=bodyhtml.toString().replace("Bilet Amountı","Ticket Amount")
             bodyhtml=bodyhtml.toString().replace("Vergi Tutarı","Tax Amount")
             bodyhtml=bodyhtml.toString().replace("Discount Tutarı","Discount Amount")
             bodyhtml=bodyhtml.toString().replace("Saat","Hour")
             bodyhtml=bodyhtml.toString().replace("Parkur","Track")
             bodyhtml=bodyhtml.toString().replace("Varış Tarihi","Arrival Date")
             bodyhtml=bodyhtml.toString().replace("V.Saat","Arrival Hour")
             bodyhtml=bodyhtml.toString().replace("Müşteri","Customer")
             bodyhtml=bodyhtml.toString().replace("Acenta Kodu","Agency Code")
             
             response.bodyText=bodyhtml;
             
          }
          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('FlightReport') + ".html";
          link.click();

          this.itemsichat = response.body
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var listreferans = [];


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.havayolubil.havayolukodu != null) {
          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/FlightReportExcel', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {

          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('FlightReport') + ".xlsx";
          link.click();

          this.itemsichat = response.body
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function beforeMount() {


  }
</script>
<style>
</style>